import { render, staticRenderFns } from "./QTHInventPrice.vue?vue&type=template&id=1b2c8d30"
import script from "./QTHInventPrice.vue?vue&type=script&lang=js"
export * from "./QTHInventPrice.vue?vue&type=script&lang=js"
import style0 from "./QTHInventPrice.vue?vue&type=style&index=0&id=1b2c8d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports